import React from "react";

type Provider = [React.ComponentType<any>, Record<string, any>?];

/**
 * Composes multiple React context providers into a single wrapper component.
 * Reduces deeply nested JSX in layout files.
 *
 * Usage:
 *   const Providers = composeProviders([
 *     [AuthProvider],
 *     [ThemeProvider, { defaultTheme: "dark" }],
 *     [DataProvider],
 *   ]);
 *   return <Providers>{children}</Providers>;
 */
export function composeProviders(providers: Provider[]) {
  return function ComposedProviders({ children }: { children: React.ReactNode }) {
    return providers.reduceRight<React.ReactNode>(
      (acc, [Provider, props]) => <Provider {...props}>{acc}</Provider>,
      children,
    );
  };
}
